import { xicon } from "../svg/iconsvg";

const LegendModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <div className="w-[420px] rounded-lg bg-white shadow-lg">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 ">
          <h2 className="text-sm font-semibold text-gray-800">Legend</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-lg outline-none"
          >
            {xicon}
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="flex items-center justify-between rounded-lg bg-[#F9FAFB] border-[1.5px] border-[#F3F4F6] px-6 py-5">
            <LegendItem color="#10B981" label="No Deductible" />
            <LegendItem color="#FBBF24" label="Coinsurance" />
            <LegendItem color="#F87171" label="Deductible" />
          </div>
        </div>
      </div>
    </div>
  );
};

const LegendItem = ({ color, label }) => (
  <div className="flex flex-col items-center gap-2 text-xs text-gray-600">
    <span
      className="h-8 w-8 rounded-full"
      style={{ backgroundColor: color }}
    />
    <span>{label}</span>
  </div>
);

export default LegendModal;
